/**
 * ClientNotice - the one line the Hub client URL contract (section 1.3.2) requires when a
 * `?client=` parameter could not be honoured: say which client is showing instead, visibly.
 * Silence there is the failure mode the multi-client plan is written against.
 *
 * Pure presentational; the shell passes the notice text from useCampaign(). Renders nothing when
 * there is nothing to say.
 */
export function ClientNotice({ notice }: { notice: string | null }) {
  if (!notice) return null;
  return (
    <div
      role="status"
      data-testid="client-notice"
      className="note"
      style={{
        margin: '10px 16px 0',
        borderLeft: '4px solid var(--amber)',
        background: 'var(--paper-2)',
      }}
    >
      <b style={{ color: 'var(--amber)' }}>Client link not applied.</b> {notice}
    </div>
  );
}
